export const COLLAPSIBLE_MENU_ICON = 'collapsible-menu-icon';
